module.exports = __webpack_public_path__ + "static/media/tph.604af640.png";